import dayjs from 'dayjs';
import React from 'react';
import { Select } from '.';

const options = [
    { label: `是`, value: true },
    { label: `否`, value: false },
];

const SelectYesNo: React.FC<React.HTMLProps<HTMLInputElement> & { onChange: (e: any) => void }> = (props) => {
    const [value, setValue] = React.useState(false);

    const handleChange = React.useCallback((e) => {
        setValue(e.value);
    }, [props.onChange]);

    React.useEffect(() => {
        props.onChange(value);
    }, [value]);

    return (
        <div>
            <Select options={options} placeholder="請選擇..." onChange={(e) => handleChange(e)}></Select>
        </div>
    );
}

export default SelectYesNo;

